import { Fragment } from 'react'
import { Divider, Typography, Box } from '@mui/material'

export default function ListaLabelValoreSeparata(props) {
  const { lista } = props

  return (
    <>
      {lista.map(({ label, valore }, index, array) =>
        <Fragment key={label + index}>
          <Box mb={1}>
            <Typography variant='body2' color='text.secondary'>
              {label}
            </Typography>
            <Typography variant='body1' fontWeight='bold'>
              {valore || '-'}
            </Typography>
          </Box>

          {index !== array.length - 1 && <Divider sx={{ my: 2 }} />}
        </Fragment>
      )}
    </>
  )
}